<script setup lang="ts">
/**
 * The key to `ZhTimeSplit`: each of the four parts as its colour swatch and its words, in the bar's own order. Set
 * it once above a list of bars so a sighted reader can tell what each colour means without hovering.
 *
 * Decoration for assistive tech (`aria-hidden`): every bar already carries its own label in words.
 */
import { TIME_SPLIT_PARTS } from '../lib/time-split'

const capitalised = (words: string): string => words.charAt(0).toUpperCase() + words.slice(1)
</script>

<template>
    <p class="zh-time-split-legend" aria-hidden="true">
        <span
            v-for="part in TIME_SPLIT_PARTS"
            :key="part.key"
            class="zh-time-split-legend__item"
            :data-part="part.key"
            :data-tone="part.tone"
        >
            <i class="zh-time-split-legend__swatch" :style="{ '--zh-time-split-colour': part.colour }" />{{
                capitalised(part.words)
            }}
        </span>
    </p>
</template>

<style scoped>
.zh-time-split-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 1.25rem;
    margin: 0;
    color: var(--muted-foreground);
    font-size: 0.75rem;
}

.zh-time-split-legend__item {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
}

.zh-time-split-legend__swatch {
    display: inline-block;
    width: 0.75rem;
    height: 0.5rem;
    border: 1px solid var(--border);
    /* Its part's `colour` in `TIME_SPLIT_PARTS`, bound per swatch exactly as the bar binds it. */
    background: var(--zh-time-split-colour);
}
</style>
